import React from 'react';
import ReactDOM from 'react-dom';
import FormModuleLookup from '../components/FormModuleLookup';
import EditorForDataGridMix from './EditorForDataGridMix';
import LookupActions from '../actions/LookupActions';
import RecordsActions from '../actions/RecordsActions';
import Warning from '../utils/Warn';
import {RecordFieldChangeStore} from '../stores/RecordsStore';
import FormItemDecimalEditor from './FormItemDecimalEditor';
import FormItemDecimalResolver from './resolver/FormItemDecimalResolver';
import FormItemConst from './FormItemConst';
import {DsAllowEditStore,UpdateDropDownContentStore} from '../stores/CmdTypeStore';

export default class FormItemDecimalEditorForDataGrid extends EditorForDataGridMix(FormItemDecimalEditor)
{

	initStores()
	{
		this.unsubscribeRecordFieldChangeStore = RecordFieldChangeStore.listen(this.onDataFieldChanged.bind(this));
		this.unsubscribeDsAllowEditStore = DsAllowEditStore.listen(this.onDsAllowEditStore.bind(this));
		this.unsubscribeUpdateDropDownContenStore = UpdateDropDownContentStore.listen(this.onUpdateDropDownContnent.bind(this));
	}

	onUpdateDropDownContnent(type,control,formModuleInstanceuuId)
	{
		if(this.props.moduleInstanceId == formModuleInstanceuuId && control == this.props.xml.name)
		{
			this.setState({dropDownContent:type});	
		}
	}


	componentWillUnmount()
	{
		this.unsubscribeRecordFieldChangeStore();
		this.unsubscribeDsAllowEditStore();
		this.inputField.removeEventListener("mousewheel",this.stopScrollFun.bind(this),{passive:false});
	}

	onDsAllowEditStore(groupAlias)
	{
		if(this.props.groupAlias == groupAlias)
		{
			let finalValue = this.props.control.getProperty_AllowEdit_Final();

			this.doSetEnable(finalValue);	
		}
		
	}

	getValue() {
	    let updated = {};
		var nowAllowEdit = $(this.inputField).attr("readonly")==undefined;
		if(!nowAllowEdit)
			return;
		this.justCommit = true;
	    let text = this.getInputNode().value;
	    var _val;
	    try
		{
			_val = FormItemDecimalResolver.getResult(text,false,this.props.allowNegative,this.props.numOfDecimals,this.props.roundOff);	
		}
		catch(e)
		{
			alert(e.message);
			return;
		}
		let _oldValue = this.props.value;
		if(_val.indexOf("false:") == 0)
		{
			Warning.show({text:_val.substr(6)});
			_val = _oldValue;
		}

	    updated[this.props.column.key] = _val;

	    if(_oldValue != updated[this.props.column.key])
	    {
	    	let propValue = this.props.value;
	    	let columnKey = this.props.column.key;
	    	let propRowData = this.props.rowData;
	    	let _control = this.props.control;
	    	RecordsActions.RecordFieldChanged(this.props.rowData,this.props.column.key,this.props.value,updated[this.props.column.key],this);
	    	if(this.props.control)
	    	{
	    		//let modifiedObject = {propValue:propValue,columnKey:columnKey,propRowData:propRowData,_val:_val};
	    		//if(!window.modifiedObjectQCache)
	    		//	window.modifiedObjectQCache = [];
	    		//window.modifiedObjectQCache.push(modifiedObject)
				/*
				//TODO 张永芳：任务系统排期 临时表 modifieldField后替换整行 与 自动保存冲突 此应为测试代码
				//由于临时表不需要保存 故最初策略为加禁用自动保存的属性 后调整为临时表弃用自动保存
				setTimeout(function(){
	    			//let _modifiedObjectItem = window.modifiedObjectQCache.shift();
	    			_control.doFieldModifiedRemote(columnKey,_val,propValue,propRowData);

				},500);*/
				let result;
				if(this.props.column.isdynamic == true)
				{
					result = this.props.control.doFieldModifiedRemote(this.props.column.dynamicFieldName,_val,_oldValue,null,null,{async:true,dynamicColumn:true,dynamicKey:this.props.column.dynamicFieldLabel});
				}
				else
				{
					result = this.props.control.doFieldModifiedRemote(this.props.column.key,_val,_oldValue,null,null,{async:true});
				}
	    		
	    		if(!result && !this.props.control.isDataMethodField)
	    		{
	    			return {};
	    		}
				if(result && !this.props.control.isDataMethodField){
					if(this.props.rowData[this.props.column.key] !=_oldValue && this.props.rowData[this.props.column.key]!=_val){
						_val = this.props.rowData[this.props.column.key];
						updated[this.props.column.key] = _val;
					}
				}
	    	}
	    }
		return updated;
	}

	componentDidMount()
	{
		if(this.props.control)
		{
			var _allowEdit = this.props.control.getProperty_AllowEdit_Final(this.props.rowData);
			this.doSetEnable(_allowEdit);
		}

		if(this.props.contextMenuData)
			$(this.inputField).contextPopup(this.props.contextMenuData);
			this.inputField.addEventListener("mousewheel",this.stopScrollFun.bind(this),{passive:false});
		
	}

	doSetEnable(enable)
	{
		var nowAllowEdit = $(this.inputField).attr("readonly")==undefined;
		if(nowAllowEdit == true && enable == false)
		{
			$(this.inputField).css("backgroundColor",FormItemConst.EDITOR_NOTEDIT_COLOR);
			$(this.inputField).attr("readonly","readonly");
		}
		else if(nowAllowEdit == false && enable == true)
		{
			$(this.inputField).css("backgroundColor","#FFFFFF");
			$(this.inputField).removeAttr("readonly");
		}
	}

	onKeyPressHandler(event)
	{
		return (/[\d|\.|\-]/.test(String.fromCharCode(event.charCode)));
	}

	render()
	{
		let rowStyles = this.getRowStyles();
		let _style = {padding:'2px',width:'100%',backgroundColor:'#ffffff',fontSize:"12px",cursor:'text'};
		if(this.state.dropDownContent != FormItemConst.DECIMALEDITOR_DROPDOWN_NONE)
			_style.paddingRight = "13px";
		let _textAlign = this.props.control.getProperty_Alignment();_style.textAlign = _textAlign.toLowerCase();
		if(rowStyles)
		{
			for(let i = 0;i<rowStyles.length;i++)
			{
				let rowStyle = rowStyles[i];
				let bool = this.props.group.analysisConditionSingleRecord1(this.props.rowData,rowStyle.recordCondition);
				if(bool)
				{
					if(rowStyle.color != -1)
						_style.color = "#"+rowStyle.color.toString(16);//原来是break 说明多个条件之间是或 现在改成了无条件覆盖
					if(rowStyle.fontSize != -1)
						_style.fontSize = rowStyle.fontSize;
					if(rowStyle.fontFamily != null)
						_style.fontFamily = rowStyle.fontFamily;
					if(rowStyle.fontWeight != null)
						_style.fontWeight = rowStyle.fontWeight;
				}
			}
		}

		let colStyles = this.getEditorStyles();
		if(colStyles)
		{
			for(let i = 0;i<colStyles.length;i++)
			{
				let colStyle = colStyles[i];
				let bool = this.props.group.analysisConditionSingleRecord1(this.props.rowData,colStyle.recordCondition);
				if(bool)
				{
					if(colStyle.color != -1)
						_style.color = "#"+colStyle.color.toString(16);//原来是break 说明多个条件之间是或 现在改成了无条件覆盖
					if(colStyle.fontSize != -1)
						_style.fontSize = colStyle.fontSize;
					if(colStyle.fontFamily != null)
						_style.fontFamily = colStyle.fontFamily;
					if(colStyle.fontWeight != null)
						_style.fontWeight = colStyle.fontWeight;
				}
			}
		}
		if(this.props.height){
			_style.maxHeight=this.props.height-2;
		}

		let cacltagdom = this.getCacltagdom();
		let numKeyBoardDom = this.getNumKeyBoardDom();
		let _v = this.props.value;
		/*if(this.props.hasInitialValue == true && this.props.control)
		{
			var _allowEdit = this.props.control.getProperty_AllowEdit_Final();

			if(_allowEdit == false)
			{
				if(this.props.column && this.props.column.key)
				{
					let _value = this.props.rowData[this.props.column.key];
					_v = _value;
				}
			}
		}*/
		return(
			<div className="FormItem_DecimalEditor_DataGrid">
				<input spellCheck="false" ref={node => this.inputField = node} id={"input"+this.props.xml.id} type="number"
			       className="form-control" style={_style} defaultValue={_v} onKeyPress = {this.onKeyPressHandler.bind(this)} onKeyDown={this.onKeyDownHandler.bind(this)}/>
				{cacltagdom}
				{numKeyBoardDom}
			</div>
		);
	}
}




// WEBPACK FOOTER //
// ./src/formItem/FormItemDecimalEditorForDataGrid.js